import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'doctor', en);

const ImportDoctorConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Import Doctor From Dispense',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.DOCTOR,
  permission: PERMISSION.CREATE,
  routes: [
    {
      path: '/doctor/import/:id',
      component: React.lazy(() => import('./ImportDoctor')),
    },
  ],
};

export default ImportDoctorConfig;
